/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './ruleset-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserProfile} from '../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-ruleset-list-page',
  template
})
export class RulesetListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.rulesets.ruleset';
  showTeamColumn = false;

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'},
    {param: 'floorPrice'},
    {label: 'advertiserExceptions', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserProfile) localUserProfile: any
  ) {
    super(LocalNetworkProfile);
    const username = localUserProfile.get('username');
    if (username === 'adnuntius@adnuntius.com' || username === 'broker1@adnuntius.com') {
      this.showTeamColumn = true;
      this.columns = this.columns.concat({param: 'team'});
    }
  }
}
